import React from 'react';
import "./index.css";
import { Link } from 'react-router-dom';

const Home =  () => {
    return (
        <div className="homePage">
            <div className="titleSection">
                <div className="center">
                    <div className="logoSection">
                        <div className="boxUnderneath"></div>
                        <img src={require("../../Images/titleLogo.png")} alt="Logo"/>
                        <div className="boxUnderline"></div>
                    </div>
                    <h1>Get unique insights from student negotiation reviews</h1>
                    <div className="buttons">
                        <Link to="/teacher/signup">
                            <button>
                                Sign up as a Teacher
                            </button>
                        </Link>
                        <Link to="/student/signup">
                            <button>
                                Sign up as a Student
                            </button>
                        </Link>
                    </div>
                    <div className="loginPrompt">
                        <Link to="/login">
                            <button className="loginBtn">
                                Already have an account? Log in
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
            <div className="studentPageSection">
                <div className="center">
                    <div className="imageContainer"><img src={require("../../Images/title1.png")} alt="Student Page"/></div>
                    <div className="textSection">
                        <h2>Review easier</h2>
                        <h3>Grades, reviews to submit, and feedback reports are easily viewable in the student dashboard</h3>
                    </div>
                </div>
            </div>
            <div className="teacherPageSection">
                <div className="center">
                    <div className="textSection">
                        <h2>Teach better</h2>
                        <h3>Manage and grade reviews in the teacher dashboard</h3>
                    </div>
                    <div className="imageContainer"><img src={require("../../Images/title2.png")} alt="Teacher Page"/></div>
                </div>
            </div>
            <div className="reviewPageSection">
                <div className="center">
                    <div className="imageContainer"><img src={require("../../Images/title3.png")} alt="Review Page"/></div>
                    <div className="textSection">
                        <h2>Learn more from reviews</h2>
                        <h3>Feedback reports let students track their performance and view feedback</h3>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;
